/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, debug) {
	'use strict';

	Module.SiteSearch.MobileMenu = function(parent) {
		var mod = this;

		mod.isProxy = mod.$ctx.is('.skinSiteSearchProxy');

		mod.on = function(callback) {
			mod.$titleContainer = mod.$ctx.find('.scsh-sitesearch-container-result-page-title');
			mod.$title = mod.$titleContainer.find('h1');
			mod.$header = mod.$ctx.closest('.modHeader');

			if(mod.isProxy) {
				// Use the real field, not the proxied one for focusing and stuff
				mod.$originalField = mod.$header.find('.top-navigation .modSiteSearch.skinSiteSearchMobileMenu .scsh-sitesearch-container input.scs-sitesearch-searchfield-input');
			}

			parent.on.call(this, callback);
		};

		// Do nothing on mobile
		mod.updateLiveSearch = mod.initLiveResultProcessor = mod.triggerLiveSearch = $.noop;

		// just show and do not calculate any width anymore
		mod.checkAndCalcTextWidth = function() {
			if(mod.isProxy && mod.$originalField.val()) {
				mod.$delEl.show();
			} else {
				mod.$delEl.hide();
			}
		};

		if(mod.isProxy) {
			mod.updateQuery = function(query) {
				mod.$title.text(query || '');
				parent.updateQuery.call(mod, query);
			};
			mod.clearSearchField = function() {
				mod.$originalField.val('');
			};
		}

		mod.activateSearchField = function() {
			// let the burger do whatever it does with a click event
			mod.$header.find('.burger > a').click();

			// header should not be sticky on search result page, because keyboard is open
			mod.$header.removeClass('is-sticky');
			debug.log('Tc.Module.SiteSearch.MobileMenu > is-sticky', false);

			// this class hides all menu items except the search field
			mod.$header.find('.top-navigation .menu-items > li:not(.modSiteSearch)').addClass('scsh-search-hidden-menus');

			$('.scsh-menu-wrapper > .menu-items').scrollTop(0);

			if(mod.isProxy) {
				mod.$originalField.focus();
			} else {
				mod.$field.focus();
			}

			mod.$delEl.removeClass('active');
		};

		mod.addEventHandlers = function() {
			// Call the shared version
			parent.addEventHandlers.call(mod);

			// Do mobile-specific stuff
			if(mod.isProxy) {
				mod.$titleContainer.click(function(event) {
					mod.activateSearchField();
					event.stopPropagation();
					event.preventDefault();
				});
			}
			mod.$form.on('submit', function () {
				$('.modHeader.scsh-mobile .burger.active > a').click(); // close mobile menu
			});
		};
	};
})(window.Tc.Module, window.Tc.$, window.debug);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.SiteSearch.MobileMenu.js
// module id = 365
// module chunks = 0